import styled from 'styled-components';
import LoadAtStop from './LoadAtStop';
import { colorSchema } from 'utils/style';

export default styled(LoadAtStop)`
  .load-at-stop {
    display: flex;
    flex-direction: column;
    font-weight: 500;

    &__item {
      display: flex;
      justify-content: space-between;
      color: ${colorSchema('grey900')};
      font-size: 1.6rem;
      margin-bottom: 0.5rem;
    }

    &__pallet-info {
      &--special {
        align-items: center;
        display: flex;
        width: 7.7rem;
        justify-content: flex-end;
      }
      text-align: right;
      width: 5rem;
    }

    &__info-button {
      align-items: center;
      display: flex;
      cursor: pointer;
      margin: 0 0.5rem;
      position: relative;
      svg {
        fill: ${colorSchema('grey500')};
      }
    }

    &__info-tooltip {
      background: ${colorSchema('white')};
      border-radius: 8px;
      box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2);
      color: ${colorSchema('grey900')};
      padding: 1rem;
      display: flex;
      font-size: 1.4rem;
      left: -54px;
      position: absolute;
      white-space: nowrap;
      bottom: 26px;
      z-index: 2;

      &:after {
        background: ${colorSchema('white')};
        content: '';
        height: 10px;
        position: absolute;
        transform: rotate(45deg);
        width: 10px;
        bottom: -5px;
        left: 57px;
      }
    }
  }
`;
